import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const getPropValues = (value) => !!value && value;
let GridComponent = class extends Mixins(MagicConfigMixin) {
  get styles() {
    const styleArray = [
      { prefix: "-cols", value: getPropValues(this.cols) },
      { prefix: "-sm-cols", value: getPropValues(this.colsSm) },
      { prefix: "-md-cols", value: getPropValues(this.colsMd) },
      { prefix: "-lg-cols", value: getPropValues(this.colsLg) },
      { prefix: "-xl-cols", value: getPropValues(this.colsXl) },
      { prefix: "-gap", value: getPropValues(this.gap) },
      {
        prefix: "-gap-horizontal",
        value: getPropValues(this.horizontalGap)
      },
      { prefix: "-gap-vertical", value: getPropValues(this.verticalGap) }
    ];
    const finalStyles = {};
    styleArray.forEach(({ prefix, value }) => {
      if (value) {
        finalStyles[`--grid${prefix}`] = value;
      }
    });
    return finalStyles;
  }
};
__decorateClass([
  Prop(Number)
], GridComponent.prototype, "cols", 2);
__decorateClass([
  Prop(Number)
], GridComponent.prototype, "colsSm", 2);
__decorateClass([
  Prop(Number)
], GridComponent.prototype, "colsMd", 2);
__decorateClass([
  Prop(Number)
], GridComponent.prototype, "colsLg", 2);
__decorateClass([
  Prop(Number)
], GridComponent.prototype, "colsXl", 2);
__decorateClass([
  Prop(Number)
], GridComponent.prototype, "gap", 2);
__decorateClass([
  Prop(Number)
], GridComponent.prototype, "horizontalGap", 2);
__decorateClass([
  Prop(Number)
], GridComponent.prototype, "verticalGap", 2);
GridComponent = __decorateClass([
  Component({
    name: "ui-grid"
  })
], GridComponent);

export default GridComponent;
